import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import Background from './Background';
import PublicHeader from './PublicHeader';
import PublicSidebar from './PublicSidebar';
import MainContent from './MainContent';
import Footer from './Footer';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Sync i18n with user locale on mount and user change
  useEffect(() => {
    const targetLocale = user?.locale || localStorage.getItem('locale') || 'ru';
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user?.locale, i18n]);

  return (
    <Background>
      {/* Main content wrapper */}
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <PublicHeader onDrawerToggle={handleDrawerToggle} />
        <PublicSidebar mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />
        <MainContent fullWidth>{children}</MainContent>
      </div>
      {/* Footer на всю ширину экрана */}
      <Footer />
    </Background>
  );
};

export default PublicLayout;